<!--
  通用设置
  lovi 2020-1-14
-->
<template>
  <div class="w100">
    <van-nav-bar
      :title="$t('personal.commonSet')"
      :fixed="true"
      left-arrow
      @click-left="_back"
    />
    <div class="scroll-wrapper">
      <scroll>
        <van-cell-group>
          <van-cell
            :title="$t('personal.multiLanguage')"
            is-link
            :value="curName"
            @click="languageFlag = true"
          />
        </van-cell-group>
      </scroll>
    </div>

    <!-- 选择扣款顺序 -->
    <van-popup v-model="languageFlag" position="bottom" get-container="body">
      <van-picker
        show-toolbar
        :title="$t('personal.languageSwitch')"
        :default-index="curIndex"
        :columns="languageList"
        @cancel="languageFlag = false"
        @confirm="confirm"
      />
    </van-popup>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "generalSet",
  meta: {
    service: false // 客服
  },
  components: {},
  data() {
    return {
      languageFlag: false,
      languageList: [{ text: this.$t("common.chinese") }, { text: "English" }],
      curIndex: 0,
      curName: ""
    };
  },
  created() {
    this.initialize();
  },
  mounted() {},
  computed: {
    ...mapGetters(["language"])
  },
  methods: {
    initialize() {
      // 初始化
      let vm = this;
      vm.curName = vm.language == "en" ? "English" : vm.$t("common.chinese");
      for (let i = 0; i < vm.languageList.length; i++) {
        if (vm.curName == vm.languageList[i].text) {
          vm.curIndex = i;
        }
      }
    },
    confirm(picker, value) {
      // 选择语言
      let vm = this;
      vm.languageFlag = false;
      vm.curIndex = value;
      vm.curName = picker.text;
      let curLanguage = localStorage.getItem("language");
      if (
        (curLanguage == "zh" && vm.curIndex == 0) ||
        (curLanguage == "en" && vm.curIndex == 1)
      ) {
        return;
      }
      let language = picker.text == "English" ? "en" : "zh";
      localStorage.setItem("language", language);
      // localStorage.setItem("homeIcon", JSON.stringify([]));
      this.$router.go(0);
    }
  },
  watch: {}
};
</script>

<style lang="less" scoped></style>
